// src/config/platforms.js

export const PLATFORMS = {
    ehr: {
        id: 'ehr',
        name: 'PrismEHR',
        shortName: 'PrismEHR',
        description: 'Electronic Health Record',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.prismehr.com',
            demo: 'demo-platform.yourcompany.com'
        }
    },
    formbuilder: {
        id: 'formbuilder',
        name: 'CuratoForm',
        shortName: 'CuratoForm',
        description: 'Healthcare Form Builder',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'app.curatoform.com',
            demo: 'demo-app.curatoform.com'
        }
    },
    prescription: {
        id: 'prescription',
        name: 'eRx Mobile',
        shortName: 'eRx Mobile',
        description: 'Electronic Prescription Platform',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'app.erxmobile.com',
            demo: 'demo.erxmobile.com'
        }
    },
    exercise: {
        id: 'exercise',
        name: 'Ready2Exercise',
        shortName: 'Ready2Exercise',
        description: 'AI Powered Fitness Platform',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.ready2exercise.com',
            demo: 'demo-platform.ready2exercise.com'
        }
    },
    rehab: {
        id: 'rehab',
        name: 'Rehab Prescribed',
        shortName: 'Rehab Prescribed',
        description: 'Home Exercise Programs',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.rehabprescribed.com',
            demo: 'demo-platform.rehabprescribed.com'
        }
    }
};

// Get current platform configuration based on environment variables
export function getCurrentPlatform() {
    const platformId = import.meta.env.VITE_PLATFORM_ID || 'ehr';
    const platform = PLATFORMS[platformId];

    if (!platform) {
        console.error(`Invalid platform ID: ${platformId}`);
        return PLATFORMS.ehr; // Fallback to EHR
    }

    return platform;
}

// Get current environment
export function getCurrentEnvironment() {
    return import.meta.env.VITE_ENVIRONMENT || 'production';
}

// Check if we're in demo environment
export function isDemoEnvironment() {
    return getCurrentEnvironment() === 'demo';
}

// Get all environment-specific configuration
export function getEnvironmentConfig() {
    const platform = getCurrentPlatform();
    const environment = getCurrentEnvironment();

    return {
        platform,
        environment,
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://test-api.rehabilitationhealth.com/api:RIB0KqtX',
        stripeKey: import.meta.env.VITE_STRIPE_KEY || '',
        privateFilesEnabled: import.meta.env.VITE_PRIVATE_FILES_ENABLED === 'true',
        appName: import.meta.env.VITE_APP_NAME || platform.name,
        appShortName: import.meta.env.VITE_APP_SHORT_NAME || platform.shortName,
        themeColor: import.meta.env.VITE_THEME_COLOR || platform.themeColor,
        domain: platform.domain[environment]
    };
}